/**
 * Training videos shown in setup, How-To Videos, and guidebook owner links.
 * howToVideos placements override these defaults; otherwise URL fields on
 * Global App Settings are used.
 */
export const DEFAULT_CUSTOMIZE_GUIDE_VIDEO_URL = "https://youtu.be/SGQccclVv_w";

/** Paste the setup-widget YouTube URL in app settings if this is left blank. */
export const DEFAULT_SETUP_INTERVIEW_VIDEO_URL = "";

/** Paste the edit-a-section YouTube URL in app settings if this is left blank. */
export const DEFAULT_EDIT_SECTION_VIDEO_URL = "";

/** Default Nearby setup how-to; override in Global App Settings. */
export const DEFAULT_NEARBY_VIDEO_URL =
  "https://www.youtube.com/watch?v=h5SjlZAvLmo";

/** Paste the advanced guidebook YouTube URL in app settings if this is left blank. */
export const DEFAULT_ADVANCED_TRAINING_VIDEO_URL = "";

export function configuredVideoUrl(value, fallback) {
  const configured = String(value || "").trim();
  return configured || fallback || "";
}

export function youtubeVideoId(url) {
  if (!url) {
    return "";
  }
  const raw = String(url).trim();
  const parts = raw
    .replace(/(>|<)/gi, "")
    .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (parts[2] !== undefined) {
    return parts[2].split(/[^0-9a-z_\-]/i)[0] || "";
  }
  if (/^[0-9A-Za-z_-]{11}$/.test(raw)) {
    return raw;
  }
  return "";
}

export function youtubeEmbedUrl(url) {
  const id = youtubeVideoId(url);
  return id ? `https://www.youtube.com/embed/${id}` : "";
}

function urlFromHowToPlacement(appSettings, placement) {
  const list = appSettings?.howToVideos;
  if (!Array.isArray(list)) {
    return null;
  }
  const found = list.find(
    (video) => String(video?.placement || "").trim() === placement,
  );
  if (!found) {
    return null;
  }
  return String(found.url || "").trim();
}

function resolvePlacementUrl(appSettings, placement, settingKey, fallback) {
  const fromList = urlFromHowToPlacement(appSettings, placement);
  if (fromList) {
    return fromList;
  }
  return configuredVideoUrl(appSettings[settingKey], fallback);
}

export function resolveTrainingVideos(appSettings = {}) {
  const customizeUrl = resolvePlacementUrl(
    appSettings,
    "customize",
    "newOwnerTrainingVideoUrl",
    DEFAULT_CUSTOMIZE_GUIDE_VIDEO_URL,
  );
  const setupUrl = resolvePlacementUrl(
    appSettings,
    "setup",
    "setupInterviewTrainingVideoUrl",
    DEFAULT_SETUP_INTERVIEW_VIDEO_URL,
  );
  const editSectionUrl = resolvePlacementUrl(
    appSettings,
    "editSection",
    "editSectionTrainingVideoUrl",
    DEFAULT_EDIT_SECTION_VIDEO_URL,
  );
  const nearbyUrl = resolvePlacementUrl(
    appSettings,
    "nearby",
    "nearbyTrainingVideoUrl",
    DEFAULT_NEARBY_VIDEO_URL,
  );
  const advancedUrl = resolvePlacementUrl(
    appSettings,
    "advanced",
    "advancedTrainingVideoUrl",
    DEFAULT_ADVANCED_TRAINING_VIDEO_URL,
  );
  return {
    setupUrl,
    customizeUrl,
    editSectionUrl,
    nearbyUrl,
    advancedUrl,
    setupEmbedUrl: youtubeEmbedUrl(setupUrl),
    customizeEmbedUrl: youtubeEmbedUrl(customizeUrl),
    editSectionEmbedUrl: youtubeEmbedUrl(editSectionUrl),
    nearbyEmbedUrl: youtubeEmbedUrl(nearbyUrl),
    advancedEmbedUrl: youtubeEmbedUrl(advancedUrl),
  };
}
